// 获取当前组件数据
const getCurCmpData = (state) => {
  const { panelList, displayDetailTabIndex, initPanelDataObj } = state;
  if (panelList.length) {
    const activedId = panelList[displayDetailTabIndex].id;
    if (initPanelDataObj[activedId]) {
      return initPanelDataObj[activedId];
    }
  }
  return {};
};

// 获取当前组件的datasource
const getCurCmpDataSourceData = (state, ctype, componentIndex) => {
  const curCmpData = getCurCmpData(state);
  return curCmpData.dataSource.filter(item => item.ctype === ctype)[componentIndex] || {};
};

// 获取组件的ctype
const getCmpCtypeByName = (cmpName) => {
  const table = {
    signalCmp: 1,
    dashboard: 2,
    singleBind: 3,
    submitCmp: 4,
  };
  return table[cmpName] ? table[cmpName] : -1;
};

// 获取当前组件的chart数据
const getCurCmpSignalData = (state, payload) => {
  const { componentIndex } = payload;
  const curCmpData = getCurCmpData(state);
  return curCmpData.signalCmp[componentIndex];
};

// 获取当前组件对dashboard数据
const getCurDashboardData = (state, payload) => {
  const { componentIndex } = payload;
  const curCmpData = getCurCmpData(state);
  return curCmpData.dashboard[componentIndex];
};

// 获取当前组件的singleBind数据
const getCurCmpSingleBindData = (state, payload) => {
  const { componentIndex } = payload;
  const curCmpData = getCurCmpData(state);
  return curCmpData.singleBind[componentIndex];
};

// 获取当前组件的submit组件数据
const getCurSubmitCmp = (state, payload) => {
  const { componentIndex } = payload;
  const curCmpData = getCurCmpData(state);
  return curCmpData.submitCmp[componentIndex];
};

// a2l寻找对应的canid
const getCanIdOfA2lSignal = (canSignalArr, dragNode) => {
  let curCanId = '';
  canSignalArr.forEach((canItem) => {
    if (canItem.signalArr[dragNode.id]) {
      curCanId = canItem.id;
    }
  });
  return curCanId;
};

// 对初始对signal chart转化为signalCmp需要对对象
const transformToSignalCmp = (chartData = []) => chartData.map((item) => {
  const { cid } = item;
  const signalSourceArr = [];
  const signalSourceCheckedArr = {};
  const signalDisplayArr = {};
  const { pos, size, ctype } = item;
  item.dataSources.forEach((dataItem) => {
    signalSourceArr.push({
      key: dataItem.key,
      text: dataItem.text,
    }); // 信号源title
    signalSourceCheckedArr[dataItem.key] = true; // chart图展示
    signalDisplayArr[dataItem.key] = true; // 信号源文字展示
  });
  return {
    cid,
    ctype,
    pos,
    size,
    signalSourceArr,
    signalSourceCheckedArr,
    signalDisplayArr,
    // displayDataArr: [{ key: '888', values: [{ time: '2018-01', value: '1' }] }],
    displayDataArr: [],
  };
});

// 对初始的dashboard 转化为dashboard所需要展示的对象
const transformToDashboard = (dashboardData = []) => dashboardData.map((item) => {
  const { cid } = item;
  const { pos, size } = item;
  return {
    cid,
    pos,
    size,
    signalArr: item.dataSources,
    displayDataArr: [],
  };
});

// 转化后台数据到singleBind数据
const transformToSingleBind = (inputData = [], self = {}) => inputData.map((item) => {
  const { cid } = item;
  const keysArray = item.dataSources;
  let singalBindCanId = '';
  const signalArr = keysArray.map((signalItem) => {
    const canSignalArr = self.getters['Engineering/canSignalArr'];
    let curSignal = JSON.parse(JSON.stringify(signalItem));
    canSignalArr.forEach((canItem) => {
      if (canItem.signalArr[signalItem.key]) {
        curSignal = canItem.signalArr[signalItem.key];
        singalBindCanId = canItem.id;
      }
    });
    return {
      comment: '',
      key: curSignal.id,
      text: curSignal.text,
      upperLimit: curSignal.upperLimit,
      lowerLimit: curSignal.lowerLimit,
    };
  });
  return singalBindCanId ? {
    cid,
    signalArr,
    displayDataArr: [],
    bindCanId: singalBindCanId,
  } : {
    cid,
    signalArr,
    displayDataArr: [],
  };
});

// 转化初始化发送组件数据
const transformToSubmit = (submitData = []) => submitData.map((item) => {
  const { cid } = item;
  const keysArray = item.dataSources.map(signalItem => ({
    ...signalItem,
    value: 0,
  }));
  return {
    cid,
    signalArr: keysArray,
    displayDataArr: [],
  };
});

// 标定量组建根据信号名称获取通道id和对应的信号对象（获取信号的最高和最低）
// getSingleBindBySignal(state, signal) {

// }

export {
  getCurCmpData,
  getCurCmpDataSourceData,
  getCmpCtypeByName,
  getCurCmpSignalData,
  getCurDashboardData,
  getCurCmpSingleBindData,
  getCurSubmitCmp,
  getCanIdOfA2lSignal,
  transformToSignalCmp,
  transformToDashboard,
  transformToSingleBind,
  transformToSubmit,
};



// WEBPACK FOOTER //
// ./src/utils/engineeringFun.js